import { Button } from "@omni/ui/components/Button/button.component";
import { ButtonComponentProps } from "@omni/ui/components/Button/button.props";

import { useStoreSearchInputContext } from "@/components/Store/StoreSearchInput/context/storeSearchInput.context";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";

type Props = Omit<
    ButtonComponentProps,
    "type" | "onClick" | "aria-label" | "test"
>;

export const SearchButton = ({ children, ...props }: Props) => {
    const { t } = useGranite();

    const { onSearchClick } = useStoreSearchInputContext();

    return (
        <Button
            {...props}
            type={"button"}
            aria-label={t("form.searchstore.submit")}
            onClick={onSearchClick}
        >
            {children}
        </Button>
    );
};
